import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><g color="#000" fontWeight={400} fill="#474747"><path d="M2 0v2h6c.428 0 1 .614 1 1v1H4c-.92 0-1.735.384-2.25.969A3.017 3.017 0 001 7c.006.72.269 1.453.781 2.031.513.579 1.31.969 2.22.969h7V3a3 3 0 00-3-3zm2 6h5v2H4c-.398 0-.567-.11-.719-.281A1.144 1.144 0 013.001 7c-.003-.28.104-.554.25-.719C3.394 6.116 3.577 6 4 6z" style={{
        lineHeight: "normal",
        InkscapeFontSpecification: "Sans",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textTransform: "none",
        marker: "none"
      }} fontSize="xx-small" fontFamily="Sans" overflow="visible" /><path d="M12 15h1c.265 0 .53-.093.719-.281l2-2 .281-.282v-.874l-.281-.282-2-2A1.015 1.015 0 0013 9h-1v1c0 .265.093.53.281.719L13.562 12l-1.28 1.281A1.015 1.015 0 0012 14v1z" style={{
        lineHeight: "normal",
        InkscapeFontSpecification: "'Bitstream Vera Sans'",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textTransform: "none",
        marker: "none"
      }} fontFamily="Bitstream Vera Sans" overflow="visible" /><path d="M.938 11v2H14v-2z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        marker: "none"
      }} fontFamily="sans-serif" overflow="visible" /></g></svg>;
}

export default SvgComponent;